import React, { useEffect } from 'react';
import { Box, Paper, Typography, Button, Chip, IconButton, Tooltip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import RefreshIcon from '@mui/icons-material/Refresh';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useComprobanteStore } from '../store/comprobanteStore';

const estadoColors: Record<string, 'success' | 'error' | 'warning' | 'info' | 'default'> = {
  ACE: 'success', REC: 'error', ENV: 'warning', PEN: 'info',
};
const estadoLabels: Record<string, string> = {
  ACE: 'Aceptado', REC: 'Rechazado', ENV: 'Enviado', PEN: 'Pendiente',
};

export const ComprobantesElectronicosPage: React.FC = () => {
  const { comprobantes, loading, fetchComprobantes, consultarEstado } = useComprobanteStore();

  useEffect(() => { fetchComprobantes(); }, [fetchComprobantes]);

  const columns: GridColDef[] = [
    { field: 'tipoDocumento', headerName: 'Tipo Doc.', width: 90 },
    { field: 'serie', headerName: 'Serie', width: 80 },
    { field: 'correlativo', headerName: 'Correlativo', width: 100 },
    { field: 'fechaEnvio', headerName: 'Fecha Envio', width: 130,
      valueFormatter: (value: string) => { if (!value) return '-'; try { return format(new Date(value), 'dd/MM/yyyy HH:mm', { locale: es }); } catch { return value; } } },
    { field: 'estadoSunat', headerName: 'Estado SUNAT', width: 130,
      renderCell: (params) => <Chip label={estadoLabels[params.value] || params.value || 'Sin enviar'} color={estadoColors[params.value] || 'default'} size="small" /> },
    { field: 'codigoRespuestaSunat', headerName: 'Codigo Resp.', width: 110 },
    { field: 'descripcionRespuestaSunat', headerName: 'Descripcion', flex: 1, minWidth: 200 },
    { field: 'intentoEnvio', headerName: 'Intentos', width: 80, type: 'number' },
    { field: 'fechaRespuesta', headerName: 'Fecha Resp.', width: 130,
      valueFormatter: (value: string) => { if (!value) return '-'; try { return format(new Date(value), 'dd/MM/yyyy HH:mm', { locale: es }); } catch { return value; } } },
    {
      field: 'actions', headerName: 'Acciones', width: 80, sortable: false,
      renderCell: (params) => (
        <Tooltip title="Consultar estado">
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); consultarEstado(params.row.idComprobanteElectronico); }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Comprobantes Electronicos</Typography>
        <Button variant="outlined" startIcon={<RefreshIcon />} onClick={() => fetchComprobantes()}>Actualizar</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid rows={comprobantes} columns={columns} getRowId={(row) => row.idComprobanteElectronico} loading={loading}
          pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          sx={{ border: 'none' }} disableRowSelectionOnClick />
      </Paper>
    </Box>
  );
};
